import React, { useState, useEffect, useRef } from "react";
import API from "../Service/Baseservice";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import CalendarIcon from "../../Assets/img/calendar.png";
import CharIcon from "../../Assets/img/word.png";
import "./News.css";
import Newspreview from "../News/Newspreview";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const NewsEdit = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const news = location.state?.news || {};
    const dateInputRef = useRef(null);
    const page = location.state?.page || 1;
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [previewData, setPreviewData] = useState(null);

    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "info",
    });
    const MAX_CHARS = 4000;
    const [lastValidDescription, setLastValidDescription] = useState(
        news?.description || ""
    );
    const [formData, setFormData] = useState({
        language_id: news?.language_id || "",
        newscategory_id: news?.newscategory_id || "",
        heading: news?.heading || "",
        description: news?.description || "",
        date: news?.date || "",
        createdBy: news?.createdBy || 1,
        updatedBy: 1,
        status: news?.status || "active",
        active: 1,
    });

    const fetchCategories = (langId) => {
        if (!langId) return;
        API.post("newscategory_list/condition", { language_id: langId })
            .then((res) => {
                const rawData = res?.data?.data?.data || [];
                const activeCategories = rawData.filter(
                    (item) => item.active === 1 || item.active === "1"
                );
                setCategories(activeCategories);
            })
            .catch((err) => {
                console.error("Failed to load categories:", err);
                setPopup({
                    show: true,
                    title: "Error",
                    message: "Failed to load categories.",
                    type: "failed",
                });
            });
    };

    useEffect(() => {
        if (formData.language_id) fetchCategories(formData.language_id);
    }, [formData.language_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "heading" && getPlainTextLength(value) > 100) return;
        setFormData({ ...formData, [name]: value });
    };

    const openDatePicker = () => {
        if (dateInputRef.current?.showPicker)
            dateInputRef.current.showPicker();
        else dateInputRef.current?.focus();
    };

    const getPlainTextLength = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return (div.textContent || div.innerText || "").length;
    };

    const handlePreview = () => {
        if (!formData.heading || !formData.description || !formData.date) {
            return setPopup({
                show: true,
                title: "Warning",
                message: "Please fill all fields to preview",
                type: "info",
            });
        }
        setPreviewData({ ...formData, news_id: "preview" });
        setShowPreview(true);
    };

    const handleSubmit = () => {
        if (
            !formData.language_id ||
            !formData.newscategory_id ||
            !formData.heading ||
            !formData.description ||
            !formData.date
        ) {
            return setPopup({
                show: true,
                title: "Warning",
                message: "Please fill all required fields",
                type: "info",
            });
        }

        setLoading(true);
        API.post("news_edit/update", { ...formData, news_id: id })
            .then((res) => {
                if (res.data?.success) {
                    setPopup({
                        show: true,
                        title: "Success",
                        message: res.data?.message || "News updated successfully!",
                        type: "success",
                    });
                    // setTimeout(() => { navigate("/news", { state: { page } }); }, 3500);
                } else {
                    setPopup({
                        show: true,
                        title: "Error",
                        message: res.data?.message || "Failed to update news!",
                        type: "error",
                    });
                }
            })
            .catch((err) => {
                console.error("Failed to update news:", err);
                setPopup({
                    show: true,
                    title: "Error",
                    message: "An error occurred while updating news.",
                    type: "error",
                });
            })
            .finally(() => setLoading(false));
    };

    return (
        <div className="newss-containeradd">

            <div className="newssadd-header">
                <h2 className="newss-title">Edit News</h2>
                <div className="header-buttons">
                    <button onClick={handlePreview} className="btn saves-btn">
                        Preview
                    </button>
                    <button
                        onClick={handleSubmit}
                        className="btn saves-btn"
                        disabled={loading}
                    >
                        {loading ? "Update" : "Update"}
                    </button>
                    <button onClick={() => navigate("/news", { state: { page } })} className="cancel-btn ">
                        Back
                    </button>
                </div>
            </div>
            
            <div className="newssadd-container">
                {/* Header */}


                {/* Form Card */}
                <div className="newssadd-formcard">
                    <div className="news-form-items">


                        <div className="news-form-group" style={{ flexDirection: "unset" }}>
                            <div style={{ flex: 1 }}>
                                <label>
                                    News Category <span className="required">*</span>
                                </label>
                                <select
                                    name="newscategory_id"
                                    value={formData.newscategory_id}
                                    onChange={handleChange}
                                    style={{ width: "100%", marginTop: "8px" }}
                                >
                                    <option value="">Select Category</option>
                                    {categories.map((cat) => (
                                        <option key={cat.newscategory_id} value={cat.newscategory_id}>
                                            {cat.category_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div style={{ flex: 1 }}>
                                <label>Date <span className="required">*</span></label>
                                <div className="news-date-wrapper" style={{ marginTop: "8px" }}>
                                    <input
                                        ref={dateInputRef}
                                        type="date"
                                        name="date"
                                        value={formData.date}
                                        onChange={handleChange}
                                        onClick={openDatePicker}
                                        placeholder="Select Date"
                                        className={formData.date ? "has-value" : ""}
                                    />
                                    <img
                                        src={CalendarIcon}
                                        alt="Calendar"
                                        className="news-edit-calendar-icon"
                                        onClick={openDatePicker}
                                        style={{ cursor: "pointer" }}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Heading */}
                        <div className="news-form-group">
                            <label className="news-description-label">
                                <span className="label-text">
                                    Heading <span className="required">*</span>
                                </span>
                                <div className="char-wrapper">
                                    <img src={CharIcon} alt="Character count" />
                                    <span className="char-count">
                                        {getPlainTextLength(formData.heading)}/100
                                    </span>
                                </div>
                            </label>
                            <input
                                type="text"
                                name="heading"
                                placeholder="Enter heading..."
                                value={formData.heading}
                                onChange={handleChange}
                            />
                        </div>

                        {/* Description */}
                        <div className="news-form-group">
                            <label className="news-description-label">
                                <span className="label-text">
                                    Description <span className="required">*</span>
                                </span>
                                <div className="char-wrapper">
                                    <img src={CharIcon} alt="Character count" />
                                    <span className="char-count">
                                        {getPlainTextLength(formData.description)}/4000
                                    </span>
                                </div>
                            </label>

                            <CKEditor
                                editor={ClassicEditor}
                                data={formData.description}

                                onChange={(event, editor) => {
                                    const html = editor.getData();

                                    const div = document.createElement("div");
                                    div.innerHTML = html;
                                    const textLength = div.textContent?.length || 0;

                                    if (textLength <= MAX_CHARS) {
                                        setLastValidDescription(html);
                                        setFormData(prev => ({
                                            ...prev,
                                            description: html
                                        }));
                                    } else {
                                        editor.setData(lastValidDescription);
                                    }
                                }}

                                config={{
                                    toolbar: [
                                        "undo", "redo", "|",
                                        "heading", "|",
                                        "bold", "italic", "underline", "|",
                                        "bulletedList", "numberedList",
                                    ],
                                }}
                                className="description1-editor"
                            />

                        </div>

                    </div>
                </div>
            </div>

            {/* ✅ Preview Modal */}
            {showPreview && (
                <div
                    className="preview-overlay"
                    onClick={() => setShowPreview(false)}
                >
                    <div
                        className="preview-modal-full"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            className="close-btn"
                            onClick={() => setShowPreview(false)}
                        >
                            ✕
                        </button>
                        <Newspreview previewNews={previewData} />
                    </div>
                </div>
            )}

            {/* ✅ Popup Message */}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>
                        <div className="popup-buttons">
                            <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ ...popup, show: false });

                                    if (popup.type === "success") {
                                        navigate("/news");
                                    }
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default NewsEdit;
